import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Pending from "./Pending";
import Declined from "./Declined";
import Accepted from "./Accepted";
import { getHostRequest } from "../../store/hostRequest/action";
import { getProfile } from "../../store/admin/action";
import useTranslation from "../../hooks/useTranslation";
import { pageHeader, headerTitle, headerDesc } from "../../util/theme";

const HostRequest = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(1);
  const dispatch = useDispatch();
  const agencyId = localStorage.getItem("agencyId");
  const { isLoading } = useSelector((state) => state.hostRequest);

  useEffect(() => {
    if (agencyId) dispatch(getProfile(agencyId));
  }, [dispatch, agencyId]);

  useEffect(() => {
    if (agencyId) dispatch(getHostRequest(agencyId, activeTab));
  }, [dispatch, activeTab, agencyId]);

  const tabs = [
    { id: 1, label: t("pending") },
    { id: 2, label: t("accepted") },
    { id: 3, label: t("decline") },
  ];

  return (
    <div
      className="page"
      style={{ background: "transparent", minHeight: "100vh", paddingBottom: 16 }}
    >
      <div style={{ maxWidth: 480, margin: "0 auto" }}>
        <div style={pageHeader}>
          <div style={headerTitle}>{t("host_request")}</div>
          <div style={headerDesc}>{t("manage_review")}</div>
        </div>

        <div style={{ padding: "8px 16px 16px" }}>
          <div
            style={{
              display: "flex",
              gap: 8,
              marginBottom: 16,
            }}
          >
            {tabs.map((tab) => {
              const active = activeTab === tab.id;
              return (
                <button
                  key={tab.id}
                  type="button"
                  className={`agency-tab-pill${active ? " active" : ""}`}
                  onClick={() => setActiveTab(tab.id)}
                  style={{
                    padding: "10px 22px",
                    fontWeight: 600,
                    fontSize: 13,
                    cursor: "pointer",
                    minHeight: 42,
                  }}
                >
                  {tab.label}
                </button>
              );
            })}
          </div>

          {!isLoading && (
            <>
              {activeTab === 1 && <Pending type={activeTab} />}
              {activeTab === 2 && <Accepted type={activeTab} />}
              {activeTab === 3 && <Declined type={activeTab} />}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default HostRequest;
